import {UICTabs} from "@/engine/UIcomponents/UICTabs.js";
import {UITemplates} from "@/engine/UITemplates.js";

export class UICFileUpload extends UICTabs {
    constructor(options) {
        let o = Object.assign({
            id: 'fileUpload',
            title: 'Upload file',
            iconBig: UITemplates.getContent('svg-my-device'),
            cancelActionName: "CANCEL",
            mainActionName: "UPLOAD",
        }, options)

        let commonDescr = `
            <div class="smallInfo">You can upload a raster map in geoTiff (<b>.tif</b>) format or a vector layer in one of the following formats: <b>.geojson</b>, <b>.kml</b>, <b>.shp</b>, <b>.dxf</b>.  
            Some file formats may not be fully supported. Please let us know if you encounter any issues while uploading your file.</div>

        `
        if (o.uploadType === "any") {
            o.items = [
                {
                    name: 'My Device',
                    picture: UITemplates.getContent('svg-my-device'),
                    content: `<div class="propertiesPane">
                                <label>FILE</label>
                                <input tabindex="0" type="file">
                              </div>
                              ${commonDescr}
                              <div class="smallInfo">For direct upload from your disk, the file size must be less than 500MB. To upload larger files, please upload your file to Google Drive or Mega.nz, then share this file by public weblink and put this weblink here</div>
                    `,
                },
                {
                    name: 'Google Drive',
                    picture: UITemplates.getContent('svg-google-drive'),
                    content: `<div class="propertiesPane">
                                <label>URL</label>
                                <input tabindex="1" type="text">
                            </div>
                              ${commonDescr}
                    `,
                },
                {
                    name: 'Mega.nz',
                    picture: UITemplates.getContent('svg-mega-nz'),
                    content: `<div class="propertiesPane">
                                <label>URL</label>
                                <input tabindex="2" type="text">
                            </div>
                              ${commonDescr}
                    `,
                }
            ]
        } else if (options.uploadType === "shape") {
            o.items = [
                {
                    name: 'Select shape file to upload',
                    content: `<div class="propertiesPane">
                                <label>FILE</label>
                                <input tabindex="0" type="file">
                              </div>
                              <div class="smallInfo">Uploaded shape file will be processed and displayed as a read only layer on your map</div>
                    `,
                }
            ]
        }

        super(o);
    }

    onMainAction() {
        super.onMainAction();
        let input = this._tabContentContainer(this.selectedItem()).querySelector('input')
        if (!input)
            return false

        if (input.files) {
            let file = input.files[0];
            if (!file)
                return false;
            this.worker("file", this.uploadType, file, this.target)
        } else {
            let v = input.value;
            if ((! /https:\/\/.+/.test(v)) && (! /[0-9a-zA-Z]{32}/.test(v)))
                return false;
            this.worker("url", this.uploadType, v, this.target)
        }

        return true;
    }
}
